import * as Models from "../Models";
import * as Common from "../Common/modules";

export interface IProductionApiClient {
  getProductionData(productionRequest: Models.Customer.ProductionRequest.IProductionRequest): ng.IPromise<any>;
  getDefaults(igsCustomerNumber: string): ng.IPromise<any>;
}

export class ProductionApiClient implements IProductionApiClient {
  public static $inject = ['igs.apiClientService'];

  constructor(private igsApiClientService: Common.ApiClientService.Igs.Common.IApiClientService) {
  }

  public getProductionData = (productionRequest: Models.Customer.ProductionRequest.ProductionRequest): ng.IPromise<any> => {
    return this.igsApiClientService.post("GetProductionData", productionRequest);
  }

  public getDefaults = (igsCustomerNumber: string): ng.IPromise<any> => {
    return this.igsApiClientService.get(`GetDefaults/${igsCustomerNumber}`);
  }
}
